import { CalendarDate } from '@internationalized/date';
import { DateTime } from 'luxon';

export function isoToCalendarDate(iso: string | null): CalendarDate | null {
  if (!iso) return null;
  const parsedDate = DateTime.fromISO(iso);
  if (!parsedDate.isValid) return null;
  return new CalendarDate(parsedDate.year, parsedDate.month, parsedDate.day);
}

export function calendarDateToIso(date: CalendarDate | null | undefined): string | null {
  if (!date) return null;
  const parsedDate = DateTime.fromObject({ year: date.year, month: date.month, day: date.day });
  if (!parsedDate.isValid) return null;
  return parsedDate.toISODate();
}
